import { render, staticRenderFns } from "./BrandShopList.vue?vue&type=template&id=9e1ba69a&scoped=true"
import script from "./BrandShopList.vue?vue&type=script&lang=ts"
export * from "./BrandShopList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1ba69a",
  null
  
)

export default component.exports